exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".quiz-paper {\n  margin: 20px 20px 0 20px;\n  padding: 20px 20px 40px 20px;\n  box-shadow: 0px 2px 56px 3px rgb(0 0 0 / 4%), 0px 1px 28px 0px rgb(0 0 0 / 3%), 0px 1px 43px 0px rgb(0 0 0 / 4%) !important;\n}\n\n.quizQuestion {\n  margin-bottom: 40px;\n}", ""]);

